import { Menu } from "@/models/Menu";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";

const state = {
  rows: [],
  message: new httpError()
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  setMenu(state, menu) {
    state.rows = menu;
  },
  addRow(state, menu) {
    state.rows.push(menu);
  },
  deleteRow(state) {
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, menuID) {
    state.rows.filter(function(el) {
      return el.menuID !== menuID;
    });
  },
  updateField
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("setMenu", []);
  },
  addData({ commit }, menu) {
    commit("addRow", menu);
  },
  async getMenu({ commit, dispatch }) {
    try {
      var order = await HTTP.get("order/GetMenu/");
      if (order.data == null || order.data.length == 0) {
        order.data = [new Menu()];
      }
      commit("setMenu", order.data);
      dispatch(
        "setMessage",
        new httpError({ message: "Retreived OK", httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting menu:" + err,
          httpStatus: 500
        })
      );
      return Promise.reject(err);
    }
  },
  getStatus({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      if (rootState.orders.rows[0].orderID == 0) return resolve(null);
      HTTP.get("order/getOrderSavedStatus/" + rootState.orders.rows[0].orderID)
        .then(data => {
          if (data.data.length > 0) {
            commit("setMenu", data.data);
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "unable to retrieve status" + err.message,
              httpStatus: 500
            })
          );
          reject(err.message);
        });
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
